

// 登录注册

export const USER_GET_TOKEN = 'USER_GET_TOKEN'
export const USER_GET_USERINFO = 'USER_GET_USERINFO'
export const USER_LOGIN_EXIT = 'USER_LOGIN_EXIT'
export const USER_GET_LOGIN_BG = 'USER_GET_LOGIN_BG'
export const USER_GET_USERTYPE = 'USER_GET_USERTYPE'